<template>
  <div class="step-bar-container">
    <Step
      :state="isActive(1)"
      :number="1"
      :title="$t('dashboard.parametrable.modale.creation.dashboard.stepper.denomination')"
    />
    <Step
      :state="isActive(2)"
      :number="2"
      :title="$t('dashboard.parametrable.modale.creation.dashboard.stepper.perimetre')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Step, { StepState } from '../../../components/ui-components/Step.vue';

export default defineComponent({
    components: {
        Step,
    },
    setup() {
        return {
            StepState,
        };
    },
    props: {
        step: { type: Number, required: true },
    },
    methods: {
        isActive(n: number) {
            if (n < this.step) {
                return StepState.valid;
            } else {
                return n === this.step ? StepState.active : StepState.inactive;
            }
        },
    },
    computed: {
    },
});
</script>

<style scoped>
.step-bar-container {
  display: flex;
  width: 75%;
  background-color: #fff;
  height: 28px;
  align-items: center;
  padding: 16px 24px;
}
:deep(.step-number-container-active) {
    background-color: var(--bleu-clair);
}
:deep(.title-active) {
    color: var(--bleu-clair);
}
</style>
